import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2019. Plesk International GmbH. All rights reserved.
import classNames from 'classnames';
import React, { isValidElement, cloneElement } from 'react';
import Icon from './Icon';
export var create = function create(icon) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!icon) {
    return icon;
  }

  if (isValidElement(icon)) {
    var _icon$props = icon.props,
        className = _icon$props.className,
        props = _objectWithoutProperties(_icon$props, ["className"]);

    var newProps = _objectSpread({}, defaults);

    Object.keys(props).forEach(function (name) {
      if (props[name] !== null && props[name] !== undefined) {
        newProps[name] = props[name];
      }
    });

    if (defaults.className || className) {
      newProps.className = classNames(defaults.className, className);
    }

    return cloneElement(icon, newProps);
  }

  if (_typeof(icon) === 'object') {
    var _className = icon.className,
        _props = _objectWithoutProperties(icon, ["className"]);

    return React.createElement(Icon, _extends({}, defaults, {
      className: defaults.className || _className ? classNames(defaults.className, _className) : null
    }, _props));
  }

  return React.createElement(Icon, _extends({}, defaults, {
    name: icon
  }));
};